<template>
    <section class="bs-validation">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">
                            {{ localizationStore.translate('credit.contact.form.title') }}
                        </h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="creditor_name">
                                        {{ localizationStore.translate('credit.contact.form.title.name') }}
                                    </label>
                                    <input
                                        type="text"
                                        id="creditor_name"
                                        name="creditor_name"
                                        class="form-control"
                                        v-model="creditContactStore.creditor_name"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="creditor_fax_number">
                                        {{ localizationStore.translate('credit.contact.form.title.faxnumber') }}
                                    </label>
                                    <phone-input-component
                                        @phoneInput="creditContactStore.updateFaxNumber"
                                        name="fax_number"
                                        :prop-phone="creditContactStore.fax_number"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label class="d-block" for="address">
                                        {{ localizationStore.translate('credit.contact.form.title.address') }}
                                    </label>
                                    <textarea
                                        id="address"
                                        name="address"
                                        class="form-control"
                                        rows="3"
                                        v-model="creditContactStore.address"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group">
                                    <label class="d-block" for="address_line">
                                        {{ localizationStore.translate('credit.contact.form.title.address_line') }}
                                    </label>
                                    <textarea
                                        id="address_line"
                                        name="address_line"
                                        class="form-control"
                                        rows="3"
                                        v-model="creditContactStore.address_line"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="city">
                                        {{ localizationStore.translate('credit.contact.form.title.city') }}
                                    </label>
                                    <input
                                        type="text"
                                        id="city"
                                        name="city"
                                        class="form-control"
                                        v-model="creditContactStore.city"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="state">
                                        {{ localizationStore.translate('credit.contact.form.title.state') }}
                                    </label>
                                    <input
                                        type="text"
                                        id="state"
                                        name="state"
                                        class="form-control"
                                        v-model="creditContactStore.state"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="zipcode">
                                        {{ localizationStore.translate('credit.contact.form.title.zipcode') }}
                                    </label>
                                    <input
                                        type="number"
                                        id="zipcode"
                                        name="zipcode"
                                        class="form-control"
                                        v-model="creditContactStore.zipcode"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label class="form-label" for="phone">
                                        {{ localizationStore.translate('credit.contact.form.title.phone') }}
                                    </label>
                                    <phone-input-component
                                        @phoneInput="creditContactStore.updatePhoneNumber"
                                        name="phone"
                                        :prop-phone="creditContactStore.phone"
                                    />
                                </div>
                            </div>
                            <div class="col-12">
                                <button @click="creditContactStore.create()" class="btn btn-primary">
                                    {{ localizationStore.translate('credit.contact.form.title.button.text') }}
                                </button>
                                <button
                                    v-if="this.$route.params && this.$route.params.client"
                                    class="ml-1 btn btn-info"
                                    @click="creditContactStore.type = 1"
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useCreditContactStore } from '../../stores/CreditContactStore.js'
    import { ref, reactive } from 'vue'
    export default {
        mounted() {
        },
        components: {
        },
        setup() {
            return {
                localizationStore: useLocalizationStore(),
                creditContactStore: useCreditContactStore(),
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
